/**
 * Shared display helpers for Web Analytics dashboard.
 */

export function cleanDisplayPath(path, url) {
  const raw = String(path || url || '').trim();
  if (!raw) return '/';

  try {
    if (/^file:/i.test(raw) || /^file:/i.test(String(url || ''))) {
      const u = new URL(url || raw);
      const parts = String(u.pathname || '').split(/[/\\]/).filter(Boolean);
      const file = parts[parts.length - 1] || '';
      return file ? `/${file}` : '/';
    }
  } catch (_) {
    /* ignore */
  }

  if (/^\/Users\/|^\/home\/|^[A-Za-z]:[\\/]/.test(raw)) {
    const parts = raw.split(/[/\\]/).filter(Boolean);
    const file = parts[parts.length - 1] || '';
    return file ? `/${file}` : '/';
  }

  try {
    if (/^https?:\/\//i.test(raw)) {
      return new URL(raw).pathname || '/';
    }
  } catch (_) {
    /* ignore */
  }

  return raw.startsWith('/') ? raw : `/${raw}`;
}

export function mergeTopPages(pages = []) {
  const map = new Map();
  for (const page of pages) {
    const display = cleanDisplayPath(page.path, page.url);
    const existing = map.get(display) || {
      path: display,
      full_path: page.path || page.url || display,
      url: page.url || page.path || '',
      title: page.title || null,
      views: 0,
    };
    existing.views += page.views || 0;
    if (!existing.title && page.title) existing.title = page.title;
    if (!existing.url && page.url) existing.url = page.url;
    map.set(display, existing);
  }
  return Array.from(map.values()).sort((a, b) => b.views - a.views);
}

export function normalizeReferrerDomain(domain) {
  const raw = String(domain || '')
    .trim()
    .toLowerCase();
  if (!raw || raw === 'null' || raw === 'direct') return 'direct';
  return raw.replace(/^www\./, '');
}

export function mergeReferrers(rows = []) {
  const map = new Map();
  for (const row of rows) {
    const domain = normalizeReferrerDomain(row.domain);
    const existing = map.get(domain) || { domain, count: 0 };
    existing.count += row.count || 0;
    map.set(domain, existing);
  }
  return Array.from(map.values()).sort((a, b) => b.count - a.count);
}

export function formatChange(value) {
  if (value == null) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  if (n > 0) return { text: `↑ ${n}%`, direction: 'up' };
  if (n < 0) return { text: `↓ ${Math.abs(n)}%`, direction: 'down' };
  return { text: '0%', direction: 'flat' };
}
